<template>
  <CContainer fluid>
    <div class="metro-menu">
      <div 
        class="tile tile-12 small" 
        @click="() => {
          $router.push({ path: `${rootPath}/nominaelectronica`})
        }">
        <i class="bi bi-universal-access-circle"></i>
        <span>N&oacute;mina Electr&oacute;nica</span>
      </div>
    </div>
  </CContainer>
</template>

<style>
  @import "../../../assets/css/metro-menu.css";
</style>

<script>
  import { ref } from "vue";

  export default {
    name: "HumanResourceMenu",
    components: {
    },
    data() {
      return {
        loading: false
      }
    },
    methods: {
    },
    setup() {
      const rootPath = ref("");

      return {
        rootPath
      }
    },
    mounted() {
      this.rootPath = this.$router.currentRoute.fullPath;

      console.log(this.rootPath);
    }
  }
</script>